import { render, staticRenderFns } from "./RenameImage.vue?vue&type=template&id=874eca54"
import script from "@/scripts/modal/rentalService/renameImage.js?vue&type=script&lang=js&external"
export * from "@/scripts/modal/rentalService/renameImage.js?vue&type=script&lang=js&external"
import style0 from "./RenameImage.vue?vue&type=style&index=0&id=874eca54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports